import { render, staticRenderFns } from "./loginCard.vue?vue&type=template&id=28cb388e&scoped=true&"
import script from "./loginCard.vue?vue&type=script&lang=js&"
export * from "./loginCard.vue?vue&type=script&lang=js&"
import style0 from "./loginCard.vue?vue&type=style&index=0&id=28cb388e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cb388e",
  null
  
)

export default component.exports